import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { BoardContainer } from "../board-scene/BoardContainer";

export class TutorialCursor extends Phaser.GameObjects.Image {

    private sliderTween: Phaser.Tweens.Tween;

    constructor(scene: Phaser.Scene) {
        
        super(scene, 0, 0, "texture_atlas_1", "finger_tutorial");

        this.setOrigin(.1);
        
        this.x = GameConstants.GAME_WIDTH / 2 - 10;
        this.y = GameConstants.GAME_HEIGHT / 2 + 480 * GameVars.scaleY * BoardContainer.currentInstance.scaleX;
        this.scaleY = GameVars.scaleY;

        this.sliderTween = this.scene.add.tween({
            targets: this,
            x: GameConstants.GAME_WIDTH / 2 - 10 + 14000 * GameConstants.PHYS_SCALE,
            ease: Phaser.Math.Easing.Linear,
            duration: 750,
            yoyo: false,
            repeat: -1
        });
    }

    public onTutorialStage2(): void {

        this.visible = false;

        this.sliderTween.remove();
    }

    public onTutorialStage3(): void {

        this.visible = true;
        this.setScale(1);

        this.x = GameConstants.STRIKER_TUTORIAL_PX * GameConstants.PHYS_SCALE - 15;
        this.y = GameVars.carromEngine.strikerY * GameConstants.PHYS_SCALE + 15;
        this.angle = 15;

        BoardContainer.currentInstance.add(this);

        const dx = 150 * Math.cos(GameConstants.STRIKER_TUTORIAL_SHOT_ANGLE);
        const dy = -150 * Math.sin(GameConstants.STRIKER_TUTORIAL_SHOT_ANGLE);

        this.scene.add.tween({
            targets: this,
            x: this.x + dx,
            y: this.y + dy,
            ease: Phaser.Math.Easing.Linear,
            duration: 1500,
            yoyo: false,
            repeat: -1
        });
    }
}
